module.exports = __webpack_public_path__ + "img/appAsset--create-ax.fd2f4788.svg";